import type { en } from '@/shared/i18n/locales/en';

export type Locale = 'en' | 'it' | 'es' | 'fr' | 'nl' | 'zh';

type DeepStringify<T> = T extends object
  ? { [K in keyof T]: DeepStringify<T[K]> }
  : string;

/** Schema shape derived from English — values are plain strings in all locales */
export type TranslationSchema = DeepStringify<typeof en>;

export interface LocaleOption {
  code: Locale;
  label: string;
  flag: string;
}

export const LOCALE_OPTIONS: LocaleOption[] = [
  { code: 'en', label: 'English', flag: 'fi fi-gb' },
  { code: 'it', label: 'Italiano', flag: 'fi fi-it' },
  { code: 'es', label: 'Español', flag: 'fi fi-es' },
  { code: 'fr', label: 'Français', flag: 'fi fi-fr' },
  { code: 'nl', label: 'Nederlands', flag: 'fi fi-nl' },
  { code: 'zh', label: '中文', flag: 'fi fi-cn' },
];

export const DEFAULT_LOCALE: Locale = 'it';
